/**
 * @Injectable
 * Custom http service
 *
 */

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, XHRBackend, RequestOptions, Request, RequestOptionsArgs, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { ToastyService } from 'ng2-toasty';

import { AuthService } from './auth.service';


@Injectable()

export class HttpService extends Http {

  constructor (
    backend: XHRBackend,
    options: RequestOptions,
    private authService: AuthService,
    private toastyService: ToastyService,
    private router: Router
  ) {
    super(backend, options);
  }


  /**
   * Execute request with token set
   *
   * @param		  {String|Request}      the url to query or the request itself
   * @param		  {Object}              request options
   * @return		{Observable}          of the response
   */
  request(url: string|Request, options?: RequestOptionsArgs): Observable<Response> {
    // Get token
    let token = this.authService.tokenGet();
    // If exists
    if(token) {
      // Get token Id
      let token_id = token.id;
      if (typeof url === 'string') { // meaning we have to add the token to the options, not in url
        // let's make option object
        if (!options) options = {headers: new Headers()};
        options.headers.set('Authorization', `${token_id}`);
      } else {
        // we have to add the token to the url object
        url.headers.set('Authorization', `${token_id}`);
      }
    }
    // Return parent request function or catch error with custom function
    return super.request(url, options).catch(this.catchAuthError(this));
  }

  /**
   * Catch error
   *
   * @param		  {Object}         the service itself
   * @return		{Observable}     of the response error
   */
  private catchAuthError (self: HttpService) {
   // We have to pass HttpService's own instance here as `self`
   return (res: Response) => {
     let json = res.json();
     this.toastyService.error({title: 'Erreur HttpService ' + json.error.statusCode, msg: json.error.message});
     // Redirect to login page
     if(json.error.statusCode == 401) {
       this.router.navigate(['/login']);
       this.authService.tokenReset();
     }
     return Observable.throw(res);
   };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/http.service.ts